import { Box, Icon, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import { format } from 'date-fns'
import React from 'react'

const TimeSelector = ({ selectedEvent, setSelectedEvent, setIsFirstPage, timeSlotValue }) => {
  const handleChangeStartTime = (e) => {
    if (e.target.value >= selectedEvent.end) {
      setSelectedEvent((prevTime) => ({
        date: prevTime.date,
        start: e.target.value,
        end: prevTime.end,
      }))
      setSelectedEvent((prevTime) => ({
        date: prevTime.date,
        start: prevTime.start,
        end: e.target.value + 1,
      }))
    } else {
      setSelectedEvent((prevTime) => ({
        date: prevTime.date,
        start: e.target.value,
        end: prevTime.end,
      }))
    }
  }

  const handleChangeEndTime = (e) => {
    setSelectedEvent((prevTime) => ({
      date: prevTime.date,
      start: prevTime.start,
      end: e.target.value,
    }))
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: 2,
        bottom: 0,
        padding: '20px 24px 28px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #EDEFF0',
        backgroundColor: 'primary.light',
      }}
    >
      {selectedEvent.date ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Typography
            sx={{
              width: '200px',
              padding: '12px 14px',
              backgroundColor: 'default-background.main',
              borderRadius: '4.5px',
              border: '1px solid #E5E5E5',
            }}
          >
            {format(selectedEvent.date, 'EEEE, dd/MM/yyyy')}
          </Typography>
          <AdxDropdown
            sxDropdown={{ marginBottom: -0.5, width: '130px' }}
            defaultValue={selectedEvent.start}
            value={selectedEvent.start}
            onChange={handleChangeStartTime}
          >
            {timeSlotValue.map((timeOption) => (
              <AdxMenuItem key={timeOption.value} value={timeOption.value}>
                {timeOption.time}
              </AdxMenuItem>
            ))}
          </AdxDropdown>
          <Typography>to</Typography>
          <AdxDropdown
            sxDropdown={{ marginBottom: -0.5, width: '130px' }}
            defaultValue={selectedEvent.end}
            value={selectedEvent.end}
            onChange={handleChangeEndTime}
          >
            {timeSlotValue.map((timeOption) => (
              <AdxMenuItem key={timeOption.value} value={timeOption.value}>
                {timeOption.time}
              </AdxMenuItem>
            ))}
          </AdxDropdown>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
          <Icon sx={{ fontSize: '20px', color: 'alternate.main' }}>edit</Icon>
          <Typography>Select date & time by clicking on the calendar</Typography>
        </Box>
      )}
      <AdxButton
        variant={'contained'}
        disabled={!selectedEvent.date}
        sx={{ width: '200px', marginLeft: '30px' }}
        onClick={() => setIsFirstPage(false)}
      >
        Next
      </AdxButton>
    </Box>
  )
}

export default TimeSelector
